import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReturnRequestWizard } from './ReturnRequestWizard';

type SubmitLocationState = {
  update?: { returnRequestId: number; requestNumber: string } | null;
};

/**
 * Partner: new / updated exception return (same flow as wireframe "Submit New Request" tab).
 */
export function PartnerSubmitView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [updateMode, setUpdateMode] = useState<{ returnRequestId: number; requestNumber: string } | null>(null);
  const [updateOmResponse, setUpdateOmResponse] = useState('');

  useEffect(() => {
    const st = (location.state as SubmitLocationState | null)?.update;
    if (!st) return;
    setUpdateMode(st);
    navigate(location.pathname, { replace: true, state: {} });
  }, [location.state, location.pathname, navigate]);

  return (
    <div id="partner-submit" className="tab-content active">
      <ReturnRequestWizard
        updateMode={updateMode}
        updateOmResponse={updateOmResponse}
        onUpdateOmResponseChange={setUpdateOmResponse}
        onClearUpdateMode={() => {
          setUpdateMode(null);
          setUpdateOmResponse('');
        }}
        onAfterSubmit={() => navigate('/partner/submissions')}
      />
    </div>
  );
}
